import React from "react";

const MyStory = () => {
  return (
    <div
      name="mystory"
      className="w-full h-auto bg-gradient-to-b from-gray-800 to-black text-white pt-28"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className=" pb-10 " data-aos="fade-right"  data-aos-duration="1800">
          <h2 className="text-5xl  inline border-b-4 border-gray-500">
            MyStory
          </h2>
        </div>
        <div data-aos="fade-up"  data-aos-duration="2000">
        <p className="text-sm sm:text-xl mt-10 text-gray-400" >
          <b className="text-white  text-xl sm:text-3xl">O</b><b>nce</b> upon a time, there was a young developer named <b className="text-white">EthicswalaCoder,</b>
          who had always been lovely passionated about technology and coding. He
          had learned to code at a young age and had always been fascinated by
          the way that computers and software could be used to solve complex
          problems. As <b className="text-white">EthicswalaCoder</b> grew older, he became increasingly
          interested in full stack development. He was fascinated by the idea of
          being able to work on both the front-end and back-end of a project,
          and he knew that this was the path he wanted to pursue. So, 
          <b className="text-white">EthicswalaCoder</b> decided to pursue a career as a full stack developer.
          He spent countless hours studying different programming languages and
          frameworks, and he quickly became an expert in a variety of
          technologies.
        </p>
        <br />
        <p className=" text-sm sm:text-xl  text-gray-400" >
          As he gained more experience, <b className="text-white">EthicswalaCoder</b> began to take on more
          and more challenging projects. He worked on everything from small
          websites to large enterprise applications, and he always put his heart
          and soul into every project he worked on. <b className="text-white">EthicswalaCoder</b>'s hard work
          and dedication paid off, and he soon became one of the most
          sought-after full stack developers in the industry. Despite his
          success, <b className="text-white">EthicswalaCoder</b> never lost his passion for technology and
          coding. He continued to learn new skills and technologies and always
          looked for new ways to push the boundaries of what was possible. In
          the end, <b className="text-white">EthicswalaCoder</b>'s hard work and determination had paid off,
          and he had achieved his dream of becoming a full stack developer. He
          had made a significant impact in the industry, and his contributions
          would be remembered for years to come.
        </p>
        </div>
      </div>
    </div>
  );
};

export default MyStory;
